import './AppNameInput.scss';
import { AutoComplete } from 'antd';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { DataSecurityAppName } from '@ui/applications/DataSecurityAppNames';
import { getDirectParent } from '@lib/popups';
import { haltKeyboardEventPropagation } from '@lib/events';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAsyncDefaultState } from '@hooks';
import React, { forwardRef, useCallback, useMemo, useRef, useState } from 'react';
export const defaultAppOptions = Object.values(DataSecurityAppName)
    .map((value) => ({
    label: value,
    value
}));
export const AppNameInput = forwardRef(({ defaultOpen, getPopupContainer, onChange, onClose, onOpen, onSelect, value }, ref) => {
    var _a;
    const [searchText, setSearchText] = useState('');
    const valueBackupRef = useRef(value);
    const [selectedValue, setSelectedValue] = useAsyncDefaultState(value, (initalizedValue) => {
        valueBackupRef.current = initalizedValue;
    });
    const [optionMatch] = useMemo(() => defaultAppOptions.filter((option) => { var _a; return ((_a = String(option.value)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()); }), [searchText]);
    const showCustomOption = Boolean(searchText) && !optionMatch;
    const options = useMemo(() => {
        const label = `Create New App "${searchText}"`;
        if (!showCustomOption) {
            return defaultAppOptions;
        }
        return [
            ...defaultAppOptions,
            {
                className: 'custom-app-option',
                label,
                value: searchText
            }
        ];
    }, [searchText, showCustomOption]);
    const handleOnChange = useCallback((input) => {
        setSearchText('');
        setSelectedValue(input);
        valueBackupRef.current = input;
        if (onChange) {
            onChange(input);
        }
    }, [onChange, setSelectedValue]);
    const handleOnSearch = useCallback((input) => {
        setSearchText(input);
    }, []);
    const handleDropdownChange = useCallback((open) => {
        if (open) {
            setSelectedValue('');
            if (onOpen) {
                onOpen();
            }
        }
        else if (!open && onClose) {
            onClose();
        }
    }, [onClose, onOpen, setSelectedValue]);
    const handleOnBlur = useCallback(() => {
        var _a;
        if (!selectedValue) {
            setSelectedValue((_a = valueBackupRef.current) !== null && _a !== void 0 ? _a : '');
        }
        if (onClose) {
            onClose();
        }
    }, [onClose, selectedValue, setSelectedValue]);
    return (React.createElement(AutoComplete, { className: 'app-name-input', defaultActiveFirstOption: !showCustomOption, defaultOpen: defaultOpen, filterOption: caseInsensitiveContainsFilterOption, getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getDirectParent, onBlur: handleOnBlur, onChange: handleOnChange, onDropdownVisibleChange: handleDropdownChange, onFocus: () => setSelectedValue(''), onKeyUp: haltKeyboardEventPropagation, onSearch: handleOnSearch, onSelect: onSelect, options: options, placeholder: (_a = valueBackupRef.current) !== null && _a !== void 0 ? _a : PLACEHOLDERS_COPY.APP_NAME, popupClassName: 'app-name-input-dropdown', ref: ref, showAction: ['focus', 'click'], value: selectedValue }));
});
